import { useMIDILearn } from './MIDILearnManager';
import { Button } from '@/components/ui/button';

/**
 * Wrapper for buttons that can be MIDI-learned
 */
export const MIDILearnButton = ({ 
  children, 
  action, 
  deck, 
  label, 
  onClick,
  className,
  ...props 
}) => {
  const { isLearning, learnControl } = useMIDILearn();

  const handleClick = (e) => {
    if (isLearning) {
      e.stopPropagation();
      learnControl(action, deck, label, onClick);
    } else if (onClick) {
      onClick(e);
    }
  };

  return (
    <Button
      {...props}
      className={`${className} ${isLearning ? 'ring-2 ring-yellow-400 ring-offset-2 ring-offset-black animate-pulse' : ''}`}
      onClick={handleClick}
    >
      {children}
    </Button>
  );
};

/**
 * Wrapper for sliders that can be MIDI-learned
 */
export const MIDILearnSlider = ({ 
  action, 
  deck, 
  label, 
  onValueChange,
  children,
  className,
  ...props 
}) => {
  const { isLearning, learnControl, registerCallback } = useMIDILearn();

  const handleClick = (e) => {
    if (isLearning) {
      const callback = (normalizedValue) => {
        // For sliders, convert 0-1 to appropriate range
        const max = props.max || 100;
        const min = props.min || 0;
        const value = min + (normalizedValue * (max - min));
        
        if (onValueChange) {
          onValueChange([value]);
        }
      };

      learnControl(action, deck, label, callback);
      
      // Register callback for future MIDI messages
      registerCallback(action, deck, callback);
    }
  };

  return (
    <div 
      onClick={handleClick}
      className={`${isLearning ? 'cursor-pointer' : ''}`}
    >
      <div className={`${isLearning ? 'ring-2 ring-yellow-400 ring-offset-2 ring-offset-black rounded-lg p-1' : ''}`}>
        {children}
      </div>
    </div>
  );
};
